import React from 'react';
import { Badge } from './Badge';
import { BookingStatus } from '../types';

interface BookingStatusBadgeProps {
  status: BookingStatus;
}

export const BookingStatusBadge: React.FC<BookingStatusBadgeProps> = ({ status }) => {
  const getVariant = (status: BookingStatus): 'primary' | 'success' | 'warning' | 'error' | 'info' => {
    switch (status) {
      case 'Pending':
        return 'warning';
      case 'Accepted':
        return 'info';
      case 'Completed':
        return 'success';
      case 'Cancelled':
      case 'Rejected':
        return 'error';
      default:
        return 'primary';
    }
  };

  const getDisplayText = (status: BookingStatus): string => {
    switch (status) {
      case 'Accepted':
        return 'Approved';
      case 'Rejected':
        return 'Not Approved';
      default:
        return status;
    }
  };

  return <Badge variant={getVariant(status)}>{getDisplayText(status)}</Badge>;
};
